import { Callout, Classes, Intent, Label } from '@blueprintjs/core';
import classNames from 'classnames';
import * as React from 'react';

import {
  EditableLabel,
  EditableLabelProps,
} from 'src/components/EditableLabel';

export const InlineEditableLabel = ({
  disabled = false,
  label,
  onValidate,
  testId,
  value,
  ...editableLabelProps
}: EditableLabelProps & {
  disabled?: boolean;
  label: React.ReactNode;
  testId?: string;
}) => {
  return (
    <Label
      className={classNames(
        'sd-drawer-editable-label',
        'sd-drawer-editable-label--inline',
        { [Classes.TEXT_DISABLED]: disabled }
      )}
      data-testid={testId}
    >
      <span>{label}</span>
      <Callout
        icon={null}
        intent={
          onValidate && onValidate(value) !== '' ? Intent.DANGER : Intent.NONE
        }
      >
        <EditableLabel
          className={Classes.MONOSPACE_TEXT}
          disabled={disabled}
          onValidate={onValidate}
          setValueOnChange
          value={value}
          // eslint-disable-next-line react/jsx-props-no-spreading
          {...editableLabelProps}
        />
      </Callout>
    </Label>
  );
};
